import React from "react";
import { Navigation } from "../components/web/Navigation";
import Banner from "../components/web/Banner";
import Services from "../components/web/Services";
import Features from "../components/web/Features";
import Downloads from "../components/web/Downloads";
import FAQ from "../components/web/FAQ";
import Testimonials from "../components/web/Testimonials";
import Newsletter from "../components/web/Newsletter";
import ContactUs from "../components/web/ContactUs";
import BigLogo from "../components/web/BigLogo";
import Footer from "../components/web/Footer";

const Welcome: React.FC = () => {
  return (
    <>
      <Navigation />
      <main className="main-wrapper">
        <Banner />
        <Services />
        <Features />
        <Downloads />
        <FAQ />
        <Testimonials />
        <Newsletter />
        <ContactUs />
        <BigLogo />
        <Footer />
      </main>
    </>
  );
}

export default Welcome;
